import CardItem from '../CardItem/CardItem'
import { audiomnist, pyteen, rag_img, eda, easymarks } from '../../assets'
import './Cards.css'

function Cards() {

  window.scrollTo(0, 0)
  
  return (
    <div id='projects' className='cards'>
      <h1>Check out a few of my projects!</h1>
      <div className="cards__container">
        <div className="cards__wrapper">
          <ul className="cards__items">
            <CardItem 
              src={audiomnist}
              text="Audio MNIST - CNN for Predicting Spoken Digits"
              label="Neural Network"
              path="/audio-mnist"
            />
            <CardItem 
              src={easymarks}
              text="Easy Marks - Bookmark App Using Vector Database"
              label="Vector Database"
              path="/easy-marks"
            />
          </ul>
          <ul className="cards__items">
            <CardItem 
              src={pyteen}
              text="PyTeen - CNN for Classic MNIST"
              label="Neural Network"
              path="/pyteen"
            />
            <CardItem 
              src={eda}
              text="Used Bike Prices - Regression Model Building"
              label="Data Analysis"
              path="/eda"
            />
            <CardItem 
              src={rag_img}
              text="J.A.R.V.I.S. - RAG Chatbot"
              label="RAG"
              path="/RAG"
            />
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Cards
